<template>
    <div class="breadcrumb">
        <a v-for="(level, index) in levels" :class="{done:isDone(index),active:isActive(index)}" href="#" @click="select(level.name, index)"><span>{{level.label}}</span></a>
    </div>
</template>

<script>
    export default {
        name: 'np-breadcrumb',
        props: {
            levels: Array, // [{name:'', label:''}]
            activeIndex: {
                default: 0
            },
        },
        methods: {
            isDone: function(index) {
                return index < this.activeIndex;
            },
            isActive: function(index) {
                return index === this.activeIndex;
            },
            select: function(name, index) {
                //this.activeIndex = index;
                this.$emit('update:active-index', index);
            }
        }

    }
</script>

<style lang="less" scoped>
    /**
     * A PEN BY Fazlul karim. MIT license.
     */
    @crane-blue: rgb(0 ,47, 135);
    @crane-yellow: rgb(255, 209, 0);
    @crane-red: rgb(255, 69, 57);
    @crane-black: rgb(45,42,38);

    @background: grey;
    @background-done: @crane-blue;
    @background-active: @crane-red;
    @background-hover: @crane-yellow;
    .breadcrumb {
        display: inline-block;
        border-radius: 5px;
        transform: scale(0.7);
    }

    .breadcrumb a {
        font-family: 'Roboto', sans-serif;
        text-decoration: none;
        outline: none;
        display: block;
        float: left;
        color: white;
        font-size: 14px;
        line-height: 60px;
        width: auto;
        position: relative;
        background: @background;
        padding-left: 50px;
        padding-right: 20px;
    }

    .breadcrumb a.done {
        background: @background-done;
        transition: all 0.5s;
    }
    .breadcrumb a.done:after {
        background: @background-done;
        transition: all 0.5s;
    }

    .breadcrumb a.active {
        background: @background-active;
        transition: all 0.5s;
    }

    .breadcrumb a:hover {
        background: @background-hover;
        transition: all 0.5s;
    }

    .breadcrumb a.active:after {
        background: @background-active;
        transition: all 0.5s;
    }

    .breadcrumb a:hover:after {
        background: @background-hover;
        transition: all 0.5s;
    }

    .breadcrumb a:after {
        content: "";
        position: absolute;
        top: 0;
        right: -30px;
        width: 60px;
        height: 60px;
        transform: scale(0.707) rotate(45deg);
        z-index: 1;
        background: @background;
        box-shadow: 3px -3px 0 2px rgba(255, 255, 255, 0.8);
        border-radius: 0 5px 0 50px;
    }

    /**
    .breadcrumb a:last-child:after {
        content: none;
    }

    .breadcrumb a:last-child {
        width: 342px;
    }
    */
</style>